// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"550":"e7dca37c","566":"18b0866e","648":"7d7ddb20","716":"cec04367"}[chunkId] + ".chunk.js";
};